import { startDust } from './grade-chaser-dust.js';

const config = JSON.parse(document.querySelector('#gc-runtime').textContent);
const setVisible = (node, visible) => { if (!node) return; node.inert = !visible; node.setAttribute('aria-hidden', String(!visible)); node.classList.toggle('is-open', visible); };
const focusable = node => [...node.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex="0"]')].filter(el => !el.closest('[inert]') && el.getClientRects().length);
function initStore(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const abort = new AbortController();
  const stopDust = document.querySelector('gc-video-home') ? undefined : startDust(root.querySelector('canvas'));
  const store = root.querySelector('#store-view'), info = root.querySelector('#info-panel'), drawer = root.querySelector('#store-drawer');
  const scrim = root.querySelector('.panel-scrim'), cartScrim = root.querySelector('.store-drawer-scrim'), nav = root.querySelector('.orbit-nav');
  const panels = JSON.parse(root.querySelector('[data-panel-content]').textContent);
  let active = '', lastTrigger, cartTrigger, drawerOpen = false, cartLoad = 0;
  const closeCart = () => { drawerOpen = false; cartLoad++; setVisible(drawer, false); setVisible(cartScrim, false); root.querySelector('[data-cart-open]').setAttribute('aria-expanded','false'); cartTrigger?.focus(); };
  function openPanel(name, trigger, focus = true) {
    if (drawerOpen) closeCart();
    active = ['store','events','about'].includes(name) ? name : '';
    if (trigger) lastTrigger = trigger;
    root.classList.toggle('panel-open', Boolean(active)); root.classList.toggle('store-open', active === 'store');
    setVisible(store, active === 'store'); setVisible(info, Boolean(panels[active])); setVisible(scrim, Boolean(panels[active]));
    nav.inert = Boolean(active);
    if (panels[active]) { const content = panels[active]; for (const key of ['kicker','title','copy','meta']) info.querySelector(key === 'title' ? '#panel-title' : '.panel-' + key).textContent = content[key]; }
    root.querySelectorAll('[data-panel]').forEach(el=>el.setAttribute('aria-expanded',String(el.dataset.panel===active)));
    if (!['preorder-status','policies'].includes(location.hash.slice(1))) history.replaceState(null, '', '#' + (active || 'home'));
    if (focus) { if(active) (active==='store' ? store.querySelector('.store-close') : info.querySelector('.panel-close')).focus(); else lastTrigger?.focus(); }
  }
  root.addEventListener('click', async event => {
    const target = event.target.closest('a,button'); if (!target) return;
    if (target.dataset.panel) { event.preventDefault(); openPanel(target.dataset.panel,target); }
    if (target.hasAttribute('data-close-panel')) openPanel('');
    if (target.hasAttribute('data-home')) {openPanel('');target.classList.add('is-boosted');setTimeout(()=>target.classList.remove('is-boosted'),1600);}
    if (target.hasAttribute('data-cart-close')) closeCart();
    if (target.hasAttribute('data-cart-open')) {
      event.preventDefault(); cartTrigger=target; drawerOpen=true; const load=++cartLoad;
      setVisible(drawer,true);setVisible(cartScrim,true);target.setAttribute('aria-expanded','true');drawer.querySelector('[data-cart-close]').focus();
      try {
        const response = await fetch(config.cart + '?section_id=grade-chaser-cart');
        if(!response.ok) throw new Error(config.error);
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const content = html.querySelector('[data-cart-content]');
        if (!content) throw new Error(config.error);
        if(load===cartLoad) drawer.querySelector('[data-cart-content]').replaceWith(content);
      } catch { if(drawerOpen && load===cartLoad) location.assign(config.cart); }
    }
  }, {signal:abort.signal});
  root.addEventListener('keydown', event => {
    if(event.key==='Escape') {if(drawerOpen)closeCart();else if(active)openPanel('');}
    if(event.key==='Tab' && active) {
      const scope=drawerOpen?drawer:active==='store'?store:info, items=focusable(scope), first=items[0], last=items.at(-1);
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();} else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
    }
  }, {signal:abort.signal});
  window.addEventListener('hashchange',()=>openPanel(location.hash.slice(1)),{signal:abort.signal});
  openPanel(location.hash.slice(1), null, false);
  document.addEventListener('shopify:section:unload', event=>{if(event.target.contains(root)){abort.abort();stopDust?.();}},{signal:abort.signal});
}
function initProduct(root) {
  if(root.dataset.ready)return;root.dataset.ready='true';
  const gallery=root.querySelector('[data-gallery]'), images=[...gallery.querySelectorAll('[data-gallery-image]')];let index=0;
  gallery.addEventListener('click',event=>{const control=event.target.closest('[data-gallery-step]');if(!control||!images.length)return;index=(index+Number(control.dataset.galleryStep)+images.length)%images.length;images.forEach((el,i)=>el.hidden=i!==index);gallery.querySelector('[data-gallery-count]').textContent=String(index+1).padStart(2,'0')+' / '+String(images.length).padStart(2,'0');gallery.querySelectorAll('.product-gallery-progress i').forEach((el,i)=>el.classList.toggle('is-active',i===index));});
  const form=root.querySelector('.gc-product-form');
  form.addEventListener('submit',async event=>{
    event.preventDefault();const button=form.querySelector('[name=add]'), status=form.querySelector('[data-product-status]');if(button.disabled)return;
    const label=button.textContent;button.disabled=true;button.textContent=config.adding;status.textContent='';
    try {
      const response = await fetch(config.add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || config.error);
      location.assign(config.checkout || config.cart);
    } catch (error) {
      status.textContent = error.message || config.error;
      button.disabled = false;
      button.textContent = label;
    }
  });
}
function init(scope=document){scope.querySelectorAll('[data-gc-storefront]').forEach(initStore);scope.querySelectorAll('[data-gc-product]').forEach(initProduct);}




async function submitCartUpdate(form) {
  if (form.dataset.quantityUpdating || !form.reportValidity()) return;
  const content = form.closest('[data-cart-content]');
  const inputs = [...form.querySelectorAll('input[name="updates[]"]')];
  const focusIndex = inputs.indexOf(document.activeElement);
  const status = form.querySelector('.gc-cart-status');
  const loadingText = status?.dataset.loadingText || status?.textContent;
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 12000);
  const body = new FormData(form);
  body.set('sections', 'grade-chaser-cart');
  body.set('sections_url', config.cart);
  form.dataset.quantityUpdating = 'true';
  form.setAttribute('aria-busy', 'true');
  inputs.forEach(input => input.readOnly = true);
  if (status) { status.textContent = loadingText; status.hidden = false; }
  try {
    const response = await fetch(config.cart + '/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
      signal: controller.signal
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || config.error);
    const markup = result.sections?.['grade-chaser-cart'];
    if (!markup) throw new Error(config.error);
    const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-cart-content]');
    if (!fresh) throw new Error(config.error);
    content.replaceWith(fresh);
    document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = String(result.item_count));
    if (focusIndex >= 0) fresh.querySelectorAll('input[name="updates[]"]')[focusIndex]?.focus({ preventScroll: true });
  } catch (error) {
    inputs.forEach(input => input.value = input.defaultValue);
    if (status) {
      status.textContent = error.name === 'AbortError' ? config.error : (error.message || config.error);
      status.hidden = false;
    }
  } finally {
    clearTimeout(timeout);
    delete form.dataset.quantityUpdating;
    form.removeAttribute('aria-busy');
    inputs.forEach(input => input.readOnly = false);
    if (status) status.dataset.loadingText = loadingText;
  }
}
function updateCartQuantity(button) {
  if (button.disabled) return;
  const form = button.closest('.gc-cart-form');
  const input = button.closest('[data-cart-quantity]')?.querySelector('input[name="updates[]"]');
  if (!form || !input || form.dataset.quantityUpdating) return;
  if (!input.reportValidity()) return;
  const previous = input.value;
  if (Number(button.dataset.cartQuantityStep) > 0) input.stepUp();
  else input.stepDown();
  if (input.value !== previous) submitCartUpdate(form);
}
document.addEventListener('click', event => {
  const button = event.target.closest('[data-cart-quantity-step]');
  if (button) {
    event.preventDefault();
    updateCartQuantity(button);
  }
  const lockedForm = event.target.closest('.gc-cart-form[data-quantity-updating]');
  if (lockedForm) event.preventDefault();
});
document.addEventListener('focusout', event => {
  const input = event.target.closest('.gc-cart-form input[name="updates[]"]');
  if (!input || input.value === input.defaultValue) return;
  // Let checkout submit all edited quantities, or let a stepper apply its step.
  if (event.relatedTarget?.closest('[name="checkout"], [name="update"], [data-cart-quantity-step], .gc-cart-line-remove')) return;
  submitCartUpdate(input.form);
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Enter') return;
  const input = event.target.closest('.gc-cart-form input[name="updates[]"]');
  if (!input) return;
  event.preventDefault();
  submitCartUpdate(input.form);
});
document.addEventListener('submit', event => {
  const form = event.target;
  if (!form.matches('.gc-cart-form')) return;
  if (form.dataset.quantityUpdating) { event.preventDefault(); return; }
  if (event.submitter?.name === 'checkout') return;
  event.preventDefault();
  submitCartUpdate(form);
});
window.addEventListener('pageshow', () => {
  document.querySelectorAll('.gc-cart-form').forEach(form => {
    delete form.dataset.quantityUpdating;
    form.removeAttribute('aria-busy');
    form.querySelectorAll('input[name="updates[]"]').forEach(input => input.readOnly = false);
    const status = form.querySelector('.gc-cart-status');
    if (status) status.hidden = true;
  });
});
document.documentElement.classList.add('gc-cart-enhanced');
init();
document.addEventListener('shopify:section:load', event => init(event.target));
